/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import { PropTypes } from 'prop-types';

const CustomColorPicker = ({ field, form: { setFieldValue } }) => {
  const [color, setColor] = useState(field.value);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (newColor) => {
    setFieldValue('primaryColor', newColor.hex);
    setColor(newColor.hex);
  };

  return (
    <div>
      <div
        style={{
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <div style={{
          width: '128px',
          height: '64px',
          borderRadius: '2px',
          background: color,
        }}
        />
      </div>
      {displayColorPicker ? (
        <div style={{
          position: 'absolute',
          zIndex: '2',
        }}
        >
          <div
            style={{
              position: 'fixed',
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px',
            }}
            onClick={handleClose}
          />
          <ChromePicker
            color={color}
            disableAlpha
            onChange={handleChange}
          />
        </div>
      ) : null}

    </div>
  );
};

CustomColorPicker.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default CustomColorPicker;
